var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1761 4.375H17.5455C22.3529 4.37501 26.25 8.27216 26.25 13.0795V13.1699C26.25 15.4785 25.3329 17.6925 23.7005 19.3249C22.0681 20.9573 19.854 21.8744 17.5455 21.8744H16.2664C16.2573 21.8744 16.25 21.8818 16.25 21.8908V24.7187C16.25 25.0387 16.081 25.3349 15.8056 25.4977C15.5302 25.6606 15.1893 25.6659 14.9089 25.5117L8.63358 22.0604C5.62144 20.4038 3.75 17.2387 3.75 13.8011V13.8011C3.74999 11.3011 4.74309 8.90356 6.51082 7.13583C8.27855 5.3681 10.6761 4.375 13.1761 4.375Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 11.875H18.75",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 15.625H14.25",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.e745bc36454c495aa8f2a2bb07ca62c2.svg";
export { ForwardRef as ReactComponent };